document.addEventListener("DOMContentLoaded", function () {

  // ------------------------------
  // CITY LABEL FORMATTER
  // ------------------------------
  function formatCityLabel(city) {
    switch (city) {
      case "delhi-ncr": return "Delhi-NCR";
      case "mumbai-pune": return "Mumbai-Pune";
      case "kolkata": return "Kolkata";
      case "bengaluru": return "Bengaluru";
      default: return city;
    }
  }

  // ------------------------------
  // SKIP ALL LOGIC INSIDE SHOPIFY EDITOR
  // ------------------------------
  const IN_EDITOR = window.Shopify && Shopify.designMode;
  if (IN_EDITOR) {
    console.log("[City Script] Running in Shopify Editor → Auto-detect disabled.");
    return; // ⛔ Prevent all popup + reloads + auto detect
  }

  // ------------------------------
  // ELEMENT REFERENCES
  // ------------------------------
  const popup = document.querySelector(".city-popup-main");
  const closeBtn = document.querySelector(".city-popup-content .close-city-popyp");
  const changeCityBtn = document.querySelector("a.change-city-icon");
  const submitBtn = document.querySelector(".submit-city-name");
  const citySelect = document.querySelector(".city-popup-content .select-city-wrap select.city-name");

  if (!popup || !closeBtn || !submitBtn || !citySelect) return;

  // ------------------------------
  // POPUP CONTROLS
  // ------------------------------
  function openPopup() { popup.classList.add("active"); }
  function closePopup() { popup.classList.remove("active"); }

  // ------------------------------
  // COOKIE HELPERS
  // ------------------------------
  function setCookie(name, value, minutes) {
    const d = new Date();
    d.setTime(d.getTime() + minutes * 60 * 1000);
    document.cookie = name + "=" + value + ";expires=" + d.toUTCString() + ";path=/";
  }

  function getCookie(name) {
    const prefix = name + "=";
    const parts = decodeURIComponent(document.cookie).split(";");
    for (let c of parts) {
      c = c.trim();
      if (c.indexOf(prefix) === 0) return c.substring(prefix.length);
    }
    return "";
  }

  // ------------------------------
  // SUBMIT CITY
  // ------------------------------
  submitBtn.addEventListener("click", function () {
    const userCity = citySelect.value.trim();
    if (!userCity) return alert("Please select a city");

    setCookie("userCity", userCity, 15);

    // Reload after clearing cart
    fetch("/cart/clear.js", { method: "POST" })
      .finally(() => location.reload());
  });

  // ------------------------------
  // CLOSE POPUP
  // ------------------------------
  closeBtn.addEventListener("click", closePopup);
  popup.addEventListener("click", e => {
    if (e.target.classList.contains("city-popup-main")) closePopup();
  });

  if (changeCityBtn) {
    changeCityBtn.addEventListener("click", function () {
      const saved = getCookie("userCity");
      citySelect.value = saved || "";
      openPopup();
    });
  }

  // ------------------------------
  // AUTO DETECT CITY VIA IPINFO
  // ------------------------------
  async function detectCityFromIP() {
    try {
      console.log("[City-Detect] Fetching IP data...");

      const res = await fetch("https://ipinfo.io/json?timeout=5000");
      if (!res.ok) throw new Error("Request failed");

      const data = await res.json();

      let city  = (data.city || "").toLowerCase();
      let state = (data.region || "").toLowerCase();

      const MAP = {
        "delhi": "delhi-ncr",
        "new delhi": "delhi-ncr",
        "gurugram": "delhi-ncr",
        "haryana": "delhi-ncr",
        "uttar pradesh": "delhi-ncr",

        "mumbai": "mumbai-pune",
        "pune": "mumbai-pune",
        "maharashtra": "mumbai-pune",

        "kolkata": "kolkata",
        "west bengal": "kolkata",

        "bengaluru": "bengaluru",
        "karnataka": "bengaluru"
      };

      return MAP[city] || MAP[state] || "";
    }
    catch (err) {
      console.warn("[City-Detect] Auto-detect failed", err);
      return "";
    }
  }

  // ------------------------------
  // COOKIE CHECK + AUTO DETECT
  // ------------------------------
  let cityName = getCookie("userCity");

  async function initCity() {
    if (!cityName) {
      console.log("[City-Detect] No cookie → trying auto-detect");

      const detected = await detectCityFromIP();
      if (detected) {
        setCookie("userCity", detected, 15);
        return location.reload();
      }

      return openPopup();
    }

    console.log("[City-Detect] Cookie found:", cityName);
  }
  initCity();

  // ------------------------------
  // SET SELECTED CITY NAME IN HEADER
  // ------------------------------
  if (cityName) {
    const span = document.querySelector(".cityname-qrrow-wrpa span.cityname");
    if (span) span.textContent = formatCityLabel(cityName);
  }

  // ------------------------------
  // COLLECTION VISIBILITY
  // ------------------------------
  const cityCollections = {
    "delhi-ncr": [
      ".collectionAll",
      ".muffinsDelhi",
      ".bagelsDelhi",
      ".dipsDelhi",
      ".nibblesDelhi",
      ".cookiesDelhi",
      ".lavaashDelhi",
      ".dessertsDelhi"
    ],
    "mumbai-pune": [
      ".collectionAll",
      ".muffinsMumbai",
      ".bagelsMumbai",
      ".dipsMumbai",
      ".nibblesMumbai",
      ".cookiesMumbai",
      ".lavaashMumbai",
      ".dessertsMumbai"
    ],
    "kolkata": [
      ".collectionAll",
      ".muffinsKolkata",
      ".bagelsKolkata",
      ".dipsKolkata",
      ".nibblesKolkata",
      ".cookiesKolkata",
      ".lavaashKolkata",
      ".dessertsKolkata"
    ],
    "bengaluru": [
      ".collectionAll",
      ".muffinsDelhi",
      ".bagelsDelhi",
      ".dipsDelhi",
      ".nibblesDelhi",
      ".cookiesDelhi",
      ".lavaashDelhi",
      ".dessertsBangalore"
    ]
  };

  if (cityCollections[cityName]) {
    cityCollections[cityName].forEach(sel => {
      document.querySelectorAll(sel).forEach(div => {
        div.style.display = "block";
      });
    });
  }

  // ------------------------------
  // PRODUCT VISIBILITY (NEW THEME)
  // ------------------------------
  const productCards = document.querySelectorAll("product-card");
  productCards.forEach(card => {
    card.style.display = "none";
    if (cityName && card.classList.contains(cityName)) {
      card.style.display = "block";
    }
  });

  // ------------------------------
  // CART PAGE — SET CITY
  // ------------------------------
  setTimeout(() => {
    const footerCity = document.querySelector("footer.Cart__Footer input.city-selected");
    if (footerCity) footerCity.value = cityName;

    const sidebarCity = document.querySelector("#sidebar-cart input.city-selected");
    if (sidebarCity) sidebarCity.value = cityName;
  }, 3000);

});